import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import React, { FC, useCallback, useEffect } from 'react';
import {
	Order,
	StatusRequestOrderBy,
	StudyRequestFilter,
	StudyRequestInterface,
} from '../../interfaces';
import { useTranslation } from '../../services';
import ManageRequestsTableHead from './ManageRequestsTableHead';
import ManageRequestsTableRow from './ManageRequestsTableRow';

interface ManageRequestTableInterface {
	data: StudyRequestInterface[];
	filter: StudyRequestFilter;
	onFilterChange: (value: StudyRequestFilter | object) => void;
	hidden: boolean;
}

const ManageRequestsTable: FC<ManageRequestTableInterface> = ({
	data,
	onFilterChange,
	filter,
	...props
}) => {
	const { t } = useTranslation();
	const [order, setOrder] = React.useState<Order>(filter.order || Order.ASC);
	const [orderBy, setOrderBy] = React.useState<StatusRequestOrderBy | undefined>(
		filter.orderBy
	);

	const handleRequestSort = useCallback(
		(
			event: React.MouseEvent<unknown>,
			property: StatusRequestOrderBy | undefined
		) => {
			const isAsc = orderBy === property && order === Order.ASC;
			setOrder(isAsc ? Order.DESC : Order.ASC);
			setOrderBy(property);
		},
		[order, orderBy, setOrder, setOrderBy]
	);

	useEffect(() => {
		onFilterChange({ order, orderBy });
	}, [order, orderBy]);

	return (
		<>
			<TableContainer component={Paper} {...props}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<ManageRequestsTableHead
								title="Unit"
								columnName={StatusRequestOrderBy.UNIT}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<ManageRequestsTableHead
								title="Name"
								columnName={StatusRequestOrderBy.NAME}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<ManageRequestsTableHead
								title="Email"
								columnName={StatusRequestOrderBy.EMAIL}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<ManageRequestsTableHead
								title="Phone"
								columnName={StatusRequestOrderBy.PHONE}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<ManageRequestsTableHead
								title="Submit Date"
								columnName={StatusRequestOrderBy.SUBMIT_DATE}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<ManageRequestsTableHead
								title="Status"
								columnName={StatusRequestOrderBy.STATUS}
								order={order}
								orderBy={orderBy}
								onRequestSort={handleRequestSort}
							/>
							<TableCell>{t('Description')}</TableCell>

							<TableCell></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((row) => (
							<ManageRequestsTableRow key={row.id} row={row} />
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default ManageRequestsTable;
